// Create a week (admin, from the week picker). Any date in the target week works —
// the server normalizes to Monday and never clobbers an existing week (idempotent).
import { useState } from 'preact/hooks';
import { createWeek } from '../../state/admin';
import { showNewWeek } from '../../state/adminUi';
import { pickWeek } from '../../state/schedule';
import { toast } from '../../state/toast';
import { AdminSheet } from './AdminSheet';

export function NewWeekSheet() {
  const close = () => (showNewWeek.value = false);
  const [date, setDate] = useState('');
  const [busy, setBusy] = useState(false);

  async function create() {
    if (!date) return;
    setBusy(true);
    const w = await createWeek(date);
    setBusy(false);
    if (w) {
      toast(`Week created: ${w.weekOf}`);
      pickWeek(w.weekId);
      close();
    }
  }

  return (
    <AdminSheet
      title="New week"
      sub="Pick any date in that week — it snaps to Monday."
      onClose={close}
      testId="new-week-sheet"
    >
      <input
        type="date"
        class="tap mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
        aria-label="A date in the new week"
        value={date}
        onInput={(e) => setDate((e.target as HTMLInputElement).value)}
      />
      <div class="mt-4 flex gap-2">
        <button class="btn-ghost flex-1" onClick={close} disabled={busy}>
          Cancel
        </button>
        <button
          class="btn-primary flex-1"
          data-testid="new-week-create"
          onClick={() => void create()}
          disabled={busy || !date}
        >
          {busy ? 'Creating…' : 'Create week'}
        </button>
      </div>
    </AdminSheet>
  );
}
